import Layout from '@/layouts/simple/simpleLayout'

const noPermissionRoutes = [{
  path: '/no-permission',
  component: Layout,
  children: [{
    path: '/',
    name: 'NoPermission',
    component: () => import('@/views/no-permission')
  }]
}]

export default noPermissionRoutes
